import React from 'react';

const ChatWebcamBanned = () => {

    return (
        <div className="page-not-found">
            <span>Vous n'êtes pas autorisé à accéder au chat webcam pour le moment.</span>
        </div>
    )
};

export default ChatWebcamBanned;